import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Danger } from 'iconsax-react';

/*
 * Triangolino arancione accanto al nome di un elemento in lista, con la spiegazione al passaggio del mouse
 * (14-15/10/2026): un prodotto che c'e' ma che nell'app non si vede o non si compra (corso fuori date,
 * abbonamento che rende socio…). Stesso aspetto in tutte le liste.
 */
export const AvvisoInLista = ({ testo }) => (
    <OverlayTrigger placement="top" overlay={<Tooltip>{testo}</Tooltip>}>
        <span className="sid-avviso-fuori-date" role="img" aria-label={testo} tabIndex={0}>
            <Danger size={18} variant="Bold" color="#E38100" />
        </span>
    </OverlayTrigger>
);

/** Abbonamento che rende socio: non si vede in app (l'ammissione a socio la decide la struttura). */
export const TESTO_ABBONAMENTO_SOCIO =
    "Questo abbonamento rende socio: non si vede nell'app e non si acquista online, perché l'ammissione a socio è soggetta all'approvazione della struttura (assemblea o consiglio direttivo). Si vende dal Manager, dopo l'ammissione.";

/** «Non pubblicare in app» (TASK #9, 21/10/2026): abbonamento, corso o lezione fuori dal catalogo dell'app. */
export const TESTO_NON_IN_APP =
    "Non pubblicato in app: non si vede nel catalogo dell'app e del negozio web. Si vende dal Manager e con il link d'acquisto.";

/** Nota sotto l'interruttore «Non pubblicare in app» nelle schede dei prodotti. */
export const NOTA_NON_IN_APP =
    "Il prodotto non compare nel catalogo dell'app e del negozio web: si vende dal Manager e con il link d'acquisto. Chi l'ha già acquistato continua a vederlo.";

export const AvvisoNonInApp = ({ prodotto }) =>
    prodotto?.hidden_in_app ? <AvvisoInLista testo={TESTO_NON_IN_APP} /> : null;

/* Un triangolino solo: l'abbonamento che rende socio non si vede in app comunque */
export const AvvisoAbbonamentoSocio = ({ abbonamento }) =>
    abbonamento?.grants_club_membership
        ? <AvvisoInLista testo={TESTO_ABBONAMENTO_SOCIO} />
        : <AvvisoNonInApp prodotto={abbonamento} />;

export default AvvisoInLista;
